export type PalantirLabelColors = keyof typeof PalantirLabelColorsEnum;

export enum PalantirLabelColorsEnum {
  'accepted' = 'accepted',
  'active' = 'active',
  'amber' = 'amber',
  'blue' = 'blue',
  'blue-grey' = 'blue-grey',
  'brown' = 'brown',
  'canceled' = 'canceled',
  'cyan' = 'cyan',
  'deep-orange' = 'deep-orange',
  'deep-purple' = 'deep-purple',
  'done' = 'done',
  'expired' = 'expired',
  'extended' = 'extended',
  'field-pale' = 'field-pale',
  'future' = 'future',
  'green' = 'green',
  'grey' = 'grey',
  'in-progress' = 'in-progress',
  'inProgress' = 'inProgress',
  'indigo' = 'indigo',
  'light-blue' = 'light-blue',
  'light-green' = 'light-green',
  'lime' = 'lime',
  'new' = 'new',
  'on-route' = 'on-route',
  'onNegotiation' = 'onNegotiation',
  'orange' = 'orange',
  'pending' = 'pending',
  'pink' = 'pink',
  'purple' = 'purple',
  'red' = 'red',
  'reported' = 'reported',
  'requested' = 'requested',
  'scheduled' = 'scheduled',
  'teal' = 'teal',
  'yellow' = 'yellow',
}

export const palantirLabelColorsMap: Record<PalantirLabelColors, { color: string; contrast: string }> = {
  accepted: { color: '#4CAF50', contrast: '#ffffff' },
  active: { color: '#29A37A', contrast: '#ffffff' },
  amber: { color: '#ffc107', contrast: '#000000' },
  blue: { color: '#2196f3', contrast: '#ffffff' },
  'blue-grey': { color: '#607d8b', contrast: '#ffffff' },
  brown: { color: '#795548', contrast: '#ffffff' },
  canceled: { color: '#C25AB5', contrast: '#ffffff' },
  cyan: { color: '#00bcd4', contrast: '#000000' },
  done: { color: '#24B787', contrast: '#ffffff' },
  'deep-orange': { color: '#ff5722', contrast: '#ffffff' },
  'deep-purple': { color: '#673ab7', contrast: '#ffffff' },
  expired: { color: '#FF0000', contrast: '#ffffff' },
  extended: { color: '#FFAA00', contrast: '#ffffff' },
  'field-pale': { color: '#3c4252', contrast: '#ffffff' },
  future: { color: '#00AAFF', contrast: '#ffffff' },
  green: { color: '#4caf50', contrast: '#000000' },
  grey: { color: '#9e9e9e', contrast: '#000000' },
  indigo: { color: '#3f51b5', contrast: '#ffffff' },
  'in-progress': { color: '#E4771F', contrast: '#ffffff' },
  inProgress: { color: '#E4771F', contrast: '#ffffff' },
  lime: { color: '#cddc39', contrast: '#000000' },
  'light-blue': { color: '#03a9f4', contrast: '#000000' },
  'light-green': { color: '#8bc34a', contrast: '#000000' },
  new: { color: '#3D99E9', contrast: '#ffffff' },
  orange: { color: '#ff9800', contrast: '#000000' },
  'on-route': { color: '#105BFB', contrast: '#ffffff' },
  onNegotiation: { color: '#E4771F', contrast: '#ffffff' },
  pending: { color: '#FF9800', contrast: '#ffffff' },
  pink: { color: '#E51A80', contrast: '#ffffff' },
  purple: { color: '#8000FF', contrast: '#ffffff' },
  red: { color: '#FF0000', contrast: '#ffffff' },
  reported: { color: '#F84547', contrast: '#ffffff' },
  requested: { color: '#3D99E9', contrast: '#ffffff' },
  scheduled: { color: '#105BFB', contrast: '#ffffff' },
  teal: { color: '#009688', contrast: '#ffffff' },
  yellow: { color: '#ffeb3b', contrast: '#000000' },
};
